export default __webpack_public_path__ + "static/media/right-arrow.2010c650.svg";